import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { ButtonRow } from '@components/styles';
import { Button } from 'primereact/button';
import { Dropdown } from '@components/RingilComponents/SafeDropdown';
import { Field } from '@components/framework/formfield/Field.tsx';
import SectionPanel from '@components/framework/panels/SectionPanel.tsx';
import { AiPriceAlertsMinimalSeverityEnum, InvoicePublishServiceTypeEnum } from '@api/ringil-api.v2';
import { Form as FormApi, proxiedPropertiesOf } from '@hooks/useForm/useForm';
import { Form } from '@components/pages/admin/companies/adminCompanyDetailForm.ts';
import SvgMoney from '@icons/money.svg?react';

interface ComponentProps {
  form: FormApi<Form>;
  onSave: () => void;
  saving: boolean;
}

const names = proxiedPropertiesOf<Form>();

const InvoiceSection: React.FC<ComponentProps> = ({ form, onSave, saving }) => {
  const { tr } = useTranslationLgs();

  return (
    <SectionPanel
      icon={<SvgMoney className={'w-6 h-6'} />}
      iconColor={'var(--content-tertiary)'}
      heading={tr('adminCompanyDetail.sectionInvoice', 'Invoice')}
      dataTestId={'admin-company-section-invoice'}>
      <div className={'grid grid-cols-1 lg:grid-cols-3 gap-4 items-start'}>
        <Field label={tr('AdminCompanyDetail.aiAlertSeverity', 'AI Alert severity')}>
          <Dropdown
            value={form.values.aiPriceAlertsMinimalSeverity}
            options={Object.values(AiPriceAlertsMinimalSeverityEnum).map(severity => ({
              label: tr(`AdminCompanyDetail.aiAlertSeverity${severity}`, severity),
              value: severity,
            }))}
            onChange={e => form.setFieldValue(names.aiPriceAlertsMinimalSeverity, e.value)}
          />
        </Field>
        <Field label={tr('AdminCompanyDetail.invoicePublishServiceType', 'Invoice Publish Service Type')}>
          <Dropdown
            value={form.values.invoicePublishServiceType}
            options={Object.values(InvoicePublishServiceTypeEnum).map(serviceType => ({
              label: tr(`AdminCompanyDetail.invoicePublishServiceType${serviceType}`, serviceType),
              value: serviceType,
            }))}
            onChange={e => form.setFieldValue(names.invoicePublishServiceType, e.value)}
          />
        </Field>
      </div>
      <ButtonRow>
        <Button label={tr('generic.save', 'Save')} onClick={onSave} loading={saving} disabled={saving} />
      </ButtonRow>
    </SectionPanel>
  );
};

export default InvoiceSection;
